// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/***Estilos componente aumento de texto y alto contraste**/
.toolbar-ayuda-accesibilidad {
    position: fixed;
    z-index: 99999;
    top: 43%;
    left: 0;
}



.toolbar-ayuda-accesibilidad ul li:first-child button {
    margin: 0;
    display: block;
    border-top-right-radius: 6px;
    border-top: 1px solid #004f87;
    border-right: 1px solid #004f87;
    border-left: none;
    border-bottom: 1px solid #d2d2d2;

}


.toolbar-ayuda-accesibilidad ul li:nth-child(2) button {
    margin: 0;
    display: block;
    border-top: 1px solid #d2d2d2;
    border-right: 1px solid #004f87;
    border-left: none;
    border-bottom: 1px solid #d2d2d2;

}

.toolbar-ayuda-accesibilidad ul li:last-child button {
    margin: 0;
    display: block;
    border-bottom-right-radius: 6px;
    border-top: 1px solid #d2d2d2;
    border-right: 1px solid #004f87;
    border-left: none;
    border-bottom: 1px solid #004f87;

}

.toolbar-ayuda-accesibilidad button {
    display: block;
    background: #fff;
    text-align: center;
    padding: 3px 7px;
    font-size: 18px;
    border: medium none;
    color: #004f87;
}

.toolbar-ayuda-accesibilidad button:hover {
    background: #e2e2e2 none repeat scroll 0 0;
    margin: 0;
}


.ico-aumentar {

    background: url("/src/app/resources/img/aumento.svg") no-repeat;
    height: 14px;
    width: 27px;
    display: inline-block;
    vertical-align: 0%;
    margin-right: 0%;
}

.ico-reducir {

    background: url("/src/app/resources/img/reduccion.svg") no-repeat;
    height: 14px;
    width: 27px;
    display: inline-block;
    vertical-align: 0%;
    margin-right: 0%;
}

`, "",{"version":3,"sources":["webpack://./src/app/pages/discapacidades/discapacidades.component.css"],"names":[],"mappings":";AACA,0DAA0D;AAC1D;IACI,eAAe;IACf,cAAc;IACd,QAAQ;IACR,OAAO;AACX;;;;AAIA;IACI,SAAS;IACT,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;IAC7B,+BAA+B;IAC/B,iBAAiB;IACjB,gCAAgC;;AAEpC;;;AAGA;IACI,SAAS;IACT,cAAc;IACd,6BAA6B;IAC7B,+BAA+B;IAC/B,iBAAiB;IACjB,gCAAgC;;AAEpC;;AAEA;IACI,SAAS;IACT,cAAc;IACd,+BAA+B;IAC/B,6BAA6B;IAC7B,+BAA+B;IAC/B,iBAAiB;IACjB,gCAAgC;;AAEpC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,SAAS;AACb;;;AAGA;;IAEI,+DAA+D;IAC/D,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,iEAAiE;IACjE,YAAY;IACZ,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":["\r\n/***Estilos componente aumento de texto y alto contraste**/\r\n.toolbar-ayuda-accesibilidad {\r\n    position: fixed;\r\n    z-index: 99999;\r\n    top: 43%;\r\n    left: 0;\r\n}\r\n\r\n\r\n\r\n.toolbar-ayuda-accesibilidad ul li:first-child button {\r\n    margin: 0;\r\n    display: block;\r\n    border-top-right-radius: 6px;\r\n    border-top: 1px solid #004f87;\r\n    border-right: 1px solid #004f87;\r\n    border-left: none;\r\n    border-bottom: 1px solid #d2d2d2;\r\n\r\n}\r\n\r\n\r\n.toolbar-ayuda-accesibilidad ul li:nth-child(2) button {\r\n    margin: 0;\r\n    display: block;\r\n    border-top: 1px solid #d2d2d2;\r\n    border-right: 1px solid #004f87;\r\n    border-left: none;\r\n    border-bottom: 1px solid #d2d2d2;\r\n\r\n}\r\n\r\n.toolbar-ayuda-accesibilidad ul li:last-child button {\r\n    margin: 0;\r\n    display: block;\r\n    border-bottom-right-radius: 6px;\r\n    border-top: 1px solid #d2d2d2;\r\n    border-right: 1px solid #004f87;\r\n    border-left: none;\r\n    border-bottom: 1px solid #004f87;\r\n\r\n}\r\n\r\n.toolbar-ayuda-accesibilidad button {\r\n    display: block;\r\n    background: #fff;\r\n    text-align: center;\r\n    padding: 3px 7px;\r\n    font-size: 18px;\r\n    border: medium none;\r\n    color: #004f87;\r\n}\r\n\r\n.toolbar-ayuda-accesibilidad button:hover {\r\n    background: #e2e2e2 none repeat scroll 0 0;\r\n    margin: 0;\r\n}\r\n\r\n\r\n.ico-aumentar {\r\n\r\n    background: url(\"/src/app/resources/img/aumento.svg\") no-repeat;\r\n    height: 14px;\r\n    width: 27px;\r\n    display: inline-block;\r\n    vertical-align: 0%;\r\n    margin-right: 0%;\r\n}\r\n\r\n.ico-reducir {\r\n\r\n    background: url(\"/src/app/resources/img/reduccion.svg\") no-repeat;\r\n    height: 14px;\r\n    width: 27px;\r\n    display: inline-block;\r\n    vertical-align: 0%;\r\n    margin-right: 0%;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
